import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import { State, StateContext } from "../../state";
import { AccessTime, ArrowBackIos, ArrowForwardIos, Close, CreditCard, Done, ElectricBike, Favorite, FavoriteBorder, FmdGood, FreeCancellation, KeyboardDoubleArrowUp, ShoppingCartCheckout } from "@mui/icons-material";
import ScrollToTop, { TextSlice } from "../../widgets/utils";
import { RentalDetails } from "./rental";
import { extraDevice } from "../../data/markersData";
import { Box, Button, Card, CardActions, CardContent, CardMedia, Checkbox, Divider, FormControl, FormControlLabel, Grid, ImageList, ImageListItem, InputAdornment, InputLabel, MenuItem, Modal, Select, Stack, Switch, TextField, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { DateStartInput } from "../../widgets/date";
import { calcTime, formatDistance, isSlotBookable } from "../../utils/utils.";
import { T, smsConsentText } from "../../i18n";
import { MapPreviewSingleTour } from "../MapComponent";
import { CalendarIcon } from "@mui/x-date-pickers";
import AliceCarousel from "react-alice-carousel";
import { PayButton } from "../checkout/checkout";
import { TrackService } from "../../client";
import { TourCard } from "./tour_card";
import _ from 'lodash';
import AlertDialogSlide from "../../widgets/modal";
import { GoogleLogin } from "@react-oauth/google";
import { HorizontalCarousel } from "./tour_list";
import { LazyImage } from "../../widgets/lazy_image";
import { HeightSelector } from "../../widgets/height_converter";

// Prefissi telefonici internazionali usati nel form di prenotazione.
// Il valore (code) viene salvato nel campo phone insieme al numero, es. "+39 3503254101".
export const PHONE_PREFIXES = [
  { code: '+39', label: '🇮🇹 +39' },
  { code: '+1', label: '🇺🇸 +1' },
  { code: '+44', label: '🇬🇧 +44' },
  { code: '+33', label: '🇫🇷 +33' },
  { code: '+49', label: '🇩🇪 +49' },
  { code: '+34', label: '🇪🇸 +34' },
  { code: '+41', label: '🇨🇭 +41' },
  { code: '+43', label: '🇦🇹 +43' },
  { code: '+32', label: '🇧🇪 +32' },
  { code: '+31', label: '🇳🇱 +31' },
  { code: '+351', label: '🇵🇹 +351' },
  { code: '+30', label: '🇬🇷 +30' },
  { code: '+353', label: '🇮🇪 +353' },
  { code: '+45', label: '🇩🇰 +45' },
  { code: '+46', label: '🇸🇪 +46' },
  { code: '+47', label: '🇳🇴 +47' },
  { code: '+358', label: '🇫🇮 +358' },
  { code: '+48', label: '🇵🇱 +48' },
  { code: '+420', label: '🇨🇿 +420' },
  { code: '+36', label: '🇭🇺 +36' },
  { code: '+385', label: '🇭🇷 +385' },
  { code: '+386', label: '🇸🇮 +386' },
  { code: '+40', label: '🇷🇴 +40' },
  { code: '+359', label: '🇧🇬 +359' },
  { code: '+352', label: '🇱🇺 +352' },
  { code: '+356', label: '🇲🇹 +356' },
  { code: '+61', label: '🇦🇺 +61' },
  { code: '+86', label: '🇨🇳 +86' },
  { code: '+81', label: '🇯🇵 +81' },
  { code: '+91', label: '🇮🇳 +91' },
  { code: '+55', label: '🇧🇷 +55' },
];

// Estrae prefisso e numero locale da un valore phone salvato (es. "+39 3503254101").
export const parsePhone = (full: string) => {
  const fallback = { prefix: '+39', number: '' };
  if (!full) return fallback;
  const trimmed = String(full).trim();
  // prova a riconoscere un prefisso noto (i più lunghi prima, per evitare collisioni tipo +3/+39)
  const codes = Array.from(new Set(PHONE_PREFIXES.map((p) => p.code)))
    .sort((a, b) => b.length - a.length);
  const match = codes.find((c) => trimmed.startsWith(c));
  if (match) {
    return { prefix: match, number: trimmed.slice(match.length).trim() };
  }
  // valore senza prefisso riconosciuto: tengo il default e uso le sole cifre come numero
  return { prefix: '+39', number: trimmed.replace(/^\+/, '').trim() };
};

const gridRulesFor4 = [
  {
    cols: 2,
    rows: 2
  },
  {
    cols: 1,
    rows: 1
  },
  {
    cols: 1,
    rows: 1
  },
  {
    cols: 2,
    rows: 1
  },
]

const gridRulesFor1 = [
  {
    cols: 4,
    rows: 4
  },
]

const gridRulesFor2 = [
  {
    cols: 2,
    rows: 2
  },
  {
    cols: 2,
    rows: 2
  },
]

const gridRulesFor3 = [
  {
    cols: 2,
    rows: 2
  },
  {
    cols: 2,
    rows: 1
  },
  {
    cols: 2,
    rows: 1
  },
]

const gridRules: any = {
  1: gridRulesFor1,
  2: gridRulesFor2,
  3: gridRulesFor3,
  4: gridRulesFor4
}

let devicePrice = 5;

export const modalCarouselStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '95%',
  maxWidth: 1000,
  bgcolor: 'background.paper',
  borderRadius: '8px',
  boxShadow: 24,
  alignItems: "center",
  border: 0,
  overflow: "hidden"
}

export const modalPoiStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '95%',
  maxWidth: 500,
  bgcolor: 'background.paper',
  borderRadius: '8px',
  boxShadow: 24,
  alignItems: "center",
  border: 0,
  overflow: "hidden"
}

export const Tour = () => {
    const navigate = useNavigate();
    const params = useParams();
    const { state } = useLocation();
    const disabled = state && state.disabled ? state.disabled : false
    let { tours, start, preferiteList, userInfos, setUserInfos, savePreferite, addToChart } = useContext(StateContext) as State;
    const [ items, setItems ] = useState<any[]>([]);
    const [ showDetail, setShowDetail ] = useState<number>(0);
    const [ showGally, setShowGallery ] = useState<boolean>(false);
    const [Forward, setForward] = useState<boolean>(true);
    const [Back, setBack] = useState<boolean>(false);
    const [infos, setInfos] = useState<any>({...userInfos});
    const [galleryPos, _setGalleryPos] = useState<number>(0);
    const [suggestions, setSuggestions] = useState<any>([]);
    const [openDateSelection, setOpenDateSelection] = useState<boolean>(false);
    const [ isValidInfos, setIsValidInfos ] = useState<boolean>(false);
    const [ chartObj, setChartObj] = useState<any>(undefined)
    const [timeRange, _setTimeRange] = useState<any>(undefined)
    const [detailT, setDetailT] = useState<any>(undefined)

    useEffect(() => {
      window.onscroll = () => {
        const el = document.getElementById('footer-fixed');
        if(el) {
          if (window.innerHeight + window.scrollY >= document.body.scrollHeight - 50) {
            el.style.display = "none"
          } else {
            el.style.display = "block"
          }
        };
        const mobile = window.innerWidth <= 600;
        const carrello = document.getElementById('tour-carrello-card')
        if (!mobile && carrello) {
          if((window.innerHeight + window.scrollY > document.documentElement.scrollHeight - 250 )) {
            return;
          }

          if (window.scrollY >= 100 && window.scrollY) {
            carrello.style.position = 'absolute';
            carrello.style.right = '0px'
            carrello.style.width = '400px'
            carrello.style.top = `${window.scrollY - 70}px`;
          } else {
            carrello.style.position = 'initial';
            carrello.style.width = 'auto'
          }
        }
      }
    });

    // Mostriamo subito il tour dalla cache della lista (se presente), mentre
    // in parallelo scarichiamo il dettaglio aggiornato dal server.
    const cachedT = tours.find(t => t.id === Number(params.id));
    const t = (detailT && detailT.id === Number(params.id)) ? detailT : cachedT;

    const { id } = useParams();

    // Chiamata di dettaglio: parte SEMPRE, anche se il tour è già in cache,
    // per aggiornare i dati sottostanti. Non è cachata (né server né client).
    // Se la lista non è in cache (es. link diretto al tour) è l'unica fonte.
    useEffect(() => {
      let alive = true;
      setDetailT(undefined);
      TrackService.detail(Number(params.id))
        .then((d: any) => { if (alive && d && d.id) setDetailT(d); })
        .catch(() => {});
      return () => { alive = false; };
    }, [params.id])

    useEffect(() => {
      if (!t) return;
      console.log("CAMBIATO IL TOUR SELEZIONATO RIFACCIO SHUFFLE DELLE SUGGESTIONS", id)
      setSuggestions(_.shuffle(tours.filter((x) => x.id !== t.id)).slice(0, 6))
    }, [id, t])

    const buildChartObj = () => {
      try {
        if(t && start) {
          const extraDevices = items.filter((i: any) => i.id === extraDevice[0].id).length + 1
          const _new = {
            tourId: t.id,
            tour: t,
            items,
            total,
            infos,
            timeRange,
            start: start.format(),
            end: start.add(t.routes.length, 'day').subtract(1, 'minutes').format(),
            person: extraDevices,
          }
          console.log("chartObject", _new)
          return _new
        }
        return {}
      } catch (e) {
        console.error("ERRORE", e)
        return {}
      }
    }

    useEffect(() => {
      setChartObj(buildChartObj())
    }, chartObj) // non si aggiornerà al cambiamento di chartObj perche non è [chartObj], ma va bene così


    if(!t) {
      // Nessun dato ancora disponibile: cache lista assente e dettaglio in
      // arrivo dal server. Mostriamo un placeholder invece di crashare.
      return (
        <div className="container" style={{ padding: 40, textAlign: 'center' }}>
          <ScrollToTop />
          <Typography>{T('loading')}…</Typography>
        </div>
      );
    }

    const _setShowDetails = (step: number, firstScroll?: boolean, ignoreIfBigger?: boolean, _start?: any) => {
      if(step === 1) {
        setTimeout(() => {
          document.getElementById("tour-carrello")?.scrollIntoView({ behavior: 'smooth', block: 'start' })
          const elementPosition = document.getElementById("tour-carrello")?.getBoundingClientRect().top;
          if(elementPosition) {
            const offsetPosition = elementPosition + window.pageYOffset - 80;
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth' // For smooth scrolling
            });
          }
        }, 200);
      }
      if(step > 1) {
        if(!_start && !start) {
          setOpenDateSelection(true)
          return
        }
        setTimeout(() => {
          document.getElementById("tour_chart_detail")?.scrollIntoView({ behavior: 'smooth', block: 'start' })
          const elementPosition = document.getElementById("tour_chart_detail")?.getBoundingClientRect().top;
          if(elementPosition) {
            const offsetPosition = elementPosition + window.pageYOffset - 80;
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth' // For smooth scrolling
            });
          }
        }, 200);
      }
      if (step < showDetail && ignoreIfBigger) {
        return
      }
      setShowDetail(step);
    }

    const imageList = [t.image]
    t.routes.forEach((t:any) => {
      imageList.push(...t.gallery)
    });
    const _imageList = imageList.slice(0, 4)

    const images = imageList.map((i:string) => <img src={i} onDragStart={(e) => e.preventDefault()} role="presentation"style={{width: "100%"}}/>)

    const days = t.routes.length

    const onAdd = (item: any) => {
      const _items = structuredClone(items)
      _items.push(item)
      setItems(_items)
      setChartObj({...chartObj, items: _items})
    }

    const onRemove = (item: any) => {
      const _items = structuredClone(items)
      _items.splice(_items.findIndex((i: any) => i.name === item.name), 1);
      setItems(_items)
      setChartObj({...chartObj, items: _items})
    }

    const setTall = (itemIndex: any, tall: number) => {
      const _items = structuredClone(items)
      console.log("SET TALL IN CM", tall)
      _items[itemIndex].tall = tall
      console.log(_items)
      setItems(_items)
      setChartObj({...chartObj, items: _items}  )
    }

    const setTimeRange = (range: string) => {
      _setTimeRange(range)
     setChartObj({...chartObj, timeRange: range})
    }

    const total = days ? 
      (items.filter(i => i.pricePerDay).map(i => i.price).reduce((a, b) => a + b, 0) * days)
      +
      items.filter(i => !i.pricePerDay).map(i => i.price).reduce((a, b) => a + b, 0)
      + 
      t.price: undefined
    
    const _setInfos = (infos: any) => {
      setInfos(infos)
      if(infos) {
        setUserInfos({
          name: infos.name,
          surname: infos.surname,
          email: infos.email,
          phone: infos.phone
        })
        console.log("NEW INFOS", infos)
        setChartObj({ ...chartObj, infos })
      }
    }

    const _addToChart = () => {
      addToChart(buildChartObj())
    }

    const onScrollHandler = (e: any) => {
      const div = e.target;
      const end = (div.scrollWidth - div.clientWidth - 10);
      const start = 10
      const x = div.scrollLeft
      if(x > start && x < end && !Forward) {
        setForward(true)
      }
      if(x >= end && Forward === true) {
        setForward(false)
      }

      if(x <= end  && x > start && !Back) {
        setBack(true)
      }
      if((x <= start) && Back === true) {
        setBack(false)
      }
    }
    
    const scrollLeft = (idTitle: string) => {
      const el = document.getElementById(idTitle)
      if(el) {
        el.scrollTo({ left: 100000, behavior: "smooth"})
      }
    }

    const scrollRight = (idTitle: string) => {
      const el = document.getElementById(idTitle)
      if(el) {
        el.scrollTo({ left: 0, behavior: "smooth"})
      }
    }
  
    const renderChartInline = () => {
      return (
        <Card 
          variant="outlined" 
          sx={{
            marginTop: '15px', 
            borderRadius: '25px', 
            border: "2px solid #1b76d3",
            minHeight: 'fit-content',
            height:  { xs: '545px'},
            maxHeight: {xs: '545px', md: '420px'},
            margin: { xs: "10px -10px"},
            display: 'flex',
            flexDirection: 'column'
          }} 
          id="tour_chart_detail"
        >
          <CardContent sx={{ flex: 1}}>
            {showDetail === 2 &&
              <div className="chart_inline">
                <Typography variant="h5">{T('rent_title')}</Typography>
                <Typography variant="subtitle1">{T('rent_desc')}</Typography>
                <RentalDetails 
                  catalogue={t.catalogue} 
                  items={items}
                  days={days}
                  onAdd={(item: any) => {
                    onAdd(item)
                  }} 
                  onRemove={(item: any) => onRemove(item)}
                  compact
                />
              </div>
            }
            {showDetail === 3 &&
              <div className="chart_inline">
                <Typography variant="h5">{T('extra_device_title')}</Typography>
                <Typography variant="subtitle1">{T('extra_device_desc')}</Typography>
                <RentalDetails 
                  catalogue={extraDevice} 
                  items={items}
                  days={days}
                  onAdd={(item: any) => {
                    onAdd(extraDevice[0]);
                  }}
                  onRemove={(item: any) => {
                    onRemove(item)
                  }}
                />
              </div>
            }
            {showDetail === 4 && total && 
              <div className="tour-rental-price">
                <Typography sx={{textAlign: "left", alignItems: "center", display: "flex", background: "aliceblue", margin: "-16px -16px 10px", padding: "15px"}}>
                  <ShoppingCartCheckout/>&nbsp;{T('reasume')}
                </Typography>
                <Typography variant="subtitle2" style={{textAlign: "left"}}>{T('tour_duration')}</Typography>
                <div><b><small>{`${days} ${T('day_plurar', {plural: days === 1 ? T('o') : T('i')})}`}</small></b></div>
                <br/>
                <hr/>
                <Typography variant="subtitle2" style={{textAlign: "left"}}>{T('track_unlock')}</Typography>
                {days &&
                  <>
                    <div><b><small>{`${T('tour_price')} ${t.price}€`}</small></b></div>
                    <div><b><small style={{ color: "green"}}>{T('included_device_text')}</small></b></div>
                    {items.find((i: any) => i.id === extraDevice[0].id) &&
                      <div>
                        <small><b>{items.filter((i: any) => i.id === extraDevice[0].id).length }</b>&nbsp;{`${T('extra_device')} = ${devicePrice}€`}</small>
                      </div>
                    }
                  </>
                }
                {items.length > 0 && <><br/><hr/><Typography variant="subtitle2" style={{textAlign: "left"}}>{T('selected_rent')}</Typography></>}
                {days && items.filter((i: any) => i.id !== extraDevice[0].id).sort((a:any, b:any) => a.id - b.id).map((item: any) => (
                  <div>
                    <small>1 {`${item.name} x ${days} ${T('day_plurar', {plural: days === 1 ? T('o') : T('i')})} = ${item.price * days}€`}</small>
                  </div>
                ))}
              </div>
            }
            {showDetail === 5 &&
              <div className="chart_inline">
                <Typography variant="h5">{T('info_and_payment')}</Typography>
                <Typography variant="subtitle1">{T('info_and_payment_desc')}</Typography>
                <br/>
                <InfoForm 
                  items={items} 
                  userInfos={userInfos}
                  onChange={_setInfos} 
                  onTallChange={setTall} 
                  onValidChange={(v: any) => v !== isValidInfos && setIsValidInfos(v)}
                  onTimeRangeChange={setTimeRange}
                />
              </div>
            }
          </CardContent>
          <CardActions>
            <div className="card-footer-gray">
              <Typography variant="h5" sx={{ flex: 1, marginBottom: {xs: '10px', md: '0'} }}>
                {T('total')} <s>{total}€</s>
              </Typography>
              <Grid sx={{ width: {xs : '100%', md: 'auto'}, display: 'flex'}} >
                {showDetail > 2 && 
                  <Button 
                    size="large" variant="outlined" color="warning" 
                    sx={{ borderRadius: "25px", marginRight: "15px", width: {md: 200, xs: showDetail >= 4 ? '120px': '100%'}}}
                    onClick={() => _setShowDetails(showDetail - 1)}
                  >
                    {T('back')}
                  </Button>
                }
                {(showDetail === 2 && items.length === 0 )&& 
                  <AlertDialogSlide
                    triggerButton={
                      <>
                        {T('next')}
                      </>
                    }
                    disabledTrigger={total ? false: true}
                    title={T('no_eq_selected_title')}
                    description={T('no_eq_selected_desc')}
                    okButtonText={T('no_eq_ok')}
                    cancelButtonText={T('no_eq_cancel')}
                    onConfirm={() => _setShowDetails(showDetail + 1)}
                  />
                }
                {((showDetail > 2 && showDetail < 5) || (showDetail === 2 && items.length > 0)) &&
                  <Button 
                    variant="contained" size="large"
                    sx={{ borderRadius: "25px", width: {md: 200, xs: '100%'}}}
                    onClick={() => _setShowDetails(showDetail + 1)}
                    color="primary"
                  >
                    {showDetail === 4 ? T('go_to_pay_btn'): T('next')}
                  </Button>
                }
                {showDetail === 5 &&
                <>
                  <PayButton 
                    title={T('confirm_and_pay')} 
                    data={buildChartObj()}
                    amount={total}
                    currency={'eur'}
                    disabled={!isValidInfos}
                  />
                </>
                }
              </Grid>
              {/* {showDetail === 4  &&
                <div style={{ width: '100%', marginTop: '15px'}}>
                  {items.length === 0 &&
                    <AlertDialogSlide 
                      triggerButton={
                        <>
                          <ShoppingCartRounded/>&nbsp;{T('add_chart_btn')}
                        </>
                      }
                      disabledTrigger={total ? false: true}
                      title="Nessun noleggio selezionato"
                      description="Sei sicuro di voler proseguire senza noleggiare nessuna attrezzatura? Così facendo acquisterai solo il self-guided tour e dovrai utilizzare la tua bicicletta e attrezzatura personale"
                      okButtonText="Conferma e vai al carrello"
                      cancelButtonText="Annulla"
                      onConfirm={() => {_addToChart(); navigate('../checkout')}}
                    />
                  }
                  {items.length > 0 &&
                    <AlertDialogSlide
                      triggerButton={
                        <>
                          <ShoppingCartRounded/>&nbsp;{T('add_chart_btn')}
                        </>
                      }
                      disabledTrigger={total ? false: true}
                      onTriggerClick={(() => _addToChart())}

                      title="Oggetto aggiunto al carrello"
                      description="Vai al carrello per completare il tuo acquisto"
                      okButtonText="Vai al carrello"
                      cancelButtonText="Torna alla home"
                      onConfirm={() => navigate('../checkout')}
                      onDismiss={() => navigate('/')}
                    />
                  }
                </div>
              } */}
            </div>
          </CardActions>
        </Card>
      )
    }

    const renderSuggestedTours = () => {
      return (
        <div>
          <br/><br/><br/><br/>
          <div className="gt-title">{T('like_also_title')}</div>
          <br/>
          <div className="relative">
            {suggestions.length > 3 && Forward &&
              <div className="scroll-arrow scroll-arrow-left" onClick={() => scrollLeft('suggestions')}>
                <ArrowForwardIos/>
              </div>
            }
            {suggestions.length > 3 && Back &&
              <div className="scroll-arrow scroll-arrow-right" onClick={() => scrollRight('suggestions')}>
                <ArrowBackIos sx={{ marginLeft: "4px", marginRight: "-4px"}}/>
              </div>
            }
            <div className="row-wrap gap-20 force-horizontal-scroll" id="suggestions" onScroll={onScrollHandler}>
              {suggestions.map((x:any) => (
                <TourCard tour={x} onTourClick={() => navigate(`../tour/${x.id}`)}/>
              ))}
            </div>
          </div>
        </div>
      )
    }

    const renderChartInfo = () => {
      return (
        <div style={{ padding: '5px'}}>
          <br/>
          <Divider/>
          <br/>
          <div className="row gap-15 align-top">
            <FreeCancellation style={{color: 'green'}}/>
            <div className="col">
              <Typography variant="subtitle2" className="row gap-10" style={{marginBottom: '5px'}}>{T('free_cancel_title')}</Typography>
              <Typography variant="caption">{T('free_cancel_desc_long')}</Typography>
            </div>
          </div>
          <br/>
          <div className="row gap-15 align-top">
            <CreditCard />
            <div className="col">
              <Typography variant="subtitle2" className="row gap-10" style={{marginBottom: '5px'}}>{T('pay_now_title')}</Typography>
              <Typography variant="caption">{T('pay_now_desc')}</Typography>
            </div>
          </div>
        </div>
      )
    }

    const isPreferite = preferiteList.find((t2: any) => t2.id === t.id)
    const mobile = window.innerWidth <= 600;

    return (
      <>
        <ScrollToTop />
          <div className="tour-detail-container" id="tour-container" 
          style={{ marginBottom: showDetail > 0? '0px': '80px'}}
          >
            <div className="container">
              <div className="pad-20">
                <Typography variant="h3" sx={{ fontSize: { sm: 45, xs: 25 } }}>
                  {/* <span style={{fontWeight: 500}}>{t.location}:</span>  */}
                  {t.title}
                </Typography>
                <Grid container spacing={2}>
                  <Grid size={{"xs": 12, "md":8}} sx={{position: "relative"}}>
                    <div className="badge badge-float preferiti-icon"  style={{zIndex: 2, top: 25}}
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        savePreferite(t)
                      }}>
                      {isPreferite ? 
                        <Favorite style={{fill: '#E91E63'}} />:
                        <FavoriteBorder/>
                      }
                    </div>
                    {imageList.length > 0 &&
                      <ImageList
                        sx={{ width: "100%", height:{md: 400, xs: 250}, overflow: "hidden", borderRadius: 4, cursor: "pointer" }}
                        cols={4}
                        gap={8}
                        variant="quilted"
                        onClick={() => {setShowGallery(true)}}
                      >
                      {_imageList.map((img: string, index: number) => (
                          <ImageListItem cols={gridRules[_imageList.length][index].cols} rows={gridRules[_imageList.length][index].rows}>
                            <LazyImage
                              onClick={() => _setGalleryPos(index)}
                              src={img}
                              radius={8}
                            />
                          </ImageListItem>
                        ))}
                      </ImageList>
                    }
                    <Typography>
                      <TextSlice lines={10} text={t.description} markdown showMore/>
                    </Typography>
                    {showDetail > 1 && !mobile &&
                      renderChartInline()
                    }
                    {t.routes.map((r: any, i:number) => (
                      <div>
                        {t.routes.length > 1 &&
                          <>
                            <br/><br/>
                            <br/>
                            <Typography variant="h3" className="row gap-10 day-header"><CalendarIcon style={{width: 50, height: 50}}/> {T('day')}: {i+1}</Typography>
                            <br/><br/>
                            <Typography variant="h4">{r.title}</Typography>
                            <ImageList
                              sx={{ width: "100%", height:{sm: 400, xs: 250}, borderRadius: 4, cursor: "pointer" }}
                              cols={4}
                              gap={3}
                              variant="quilted"
                              onClick={() => {setShowGallery(true)}}
                            >
                            {r.gallery.map((img: string, index: number) => (
                                <ImageListItem cols={gridRules[_imageList.length][index].cols} rows={gridRules[_imageList.length][index].rows}>
                                  <LazyImage src={img} radius={8} />
                                </ImageListItem>
                              ))}
                            </ImageList>
                            <br/>
                            <Typography variant="subtitle1">{r.description}</Typography>
                          </>
                        }
                        <br/>
                        <br/>
                        <div className="gt-title">{T('resume_title')}</div>
                        <br/>
                        <div className="col gap-20">
                          <Typography variant="subtitle1" className="row gap-15">
                            <div className="row gap-15 align-top">
                              <FreeCancellation/>
                              <div className="col">
                                <div>{T('free_cancel_title')}</div>
                                <Typography variant="caption">{T('free_cancel_desc')}</Typography>
                              </div>
                            </div>
                          </Typography>
                          <Typography variant="subtitle1" className="row gap-15"><FmdGood/>{T('start_point')}&nbsp;
                            <a className="sx-r" href={`https://maps.google.com/?q=${r.track ? r.track[0] + "," + r.track[1]: r.start_address}`} target="_blank">
                              <s>{r.start_address}</s>
                            </a>
                          </Typography>
                          <Typography variant="subtitle1" className="row gap-15"><AccessTime/>{T('duration')}<s className="sx-r">{calcTime(r.infos.distance)}</s></Typography>
                          <Typography variant="subtitle1" className="row gap-15"><ElectricBike/> {T('track_length')}<s className="sx-r">{formatDistance(r.infos.distance)}</s></Typography>
                          <Typography variant="subtitle1" className="row gap-15"><KeyboardDoubleArrowUp/>{T('difficulty')}<s className="sx-r"> {r.difficulty}</s></Typography>
                        </div>
                        {r.notes && 
                          <>
                            <Typography variant="subtitle1">Note <s className="sx-r">{r.notes}</s></Typography>
                          </>
                        }
                        <br/><br/> 
                        <MapPreviewSingleTour tour={t} onClick={() => {navigate('/map', {state: {selectedMarker: {route: r, tour: t}}})}} />
                        <br/><br/>
                        <HorizontalCarousel
                          tourList={r.pois.filter((p:any) => p.name)}
                          cardReactElement={PoiCard}
                          paramName="poi"
                          title={T('poi_title')} 
                          titleClass="gt-title"
                          hideEmpty
                          minToShow={3}
                          className="row-wrap gap-20 force-horizontal-scroll"
                          oneline
                        />
                        <br/>
                        {!mobile && 
                          <span>
                            <br/>
                            <br/><br/>
                          </span>
                        }
                        <Grid container>
                          <Grid size={{md: 3, sm: 5, xs: 12}}>
                            <div className="gt-title">{T('in_breve')}</div>
                          </Grid>
                          <Grid size={{md: 9, sm: 7, xs: 12}}>
                            {T('in_breve_desc')}
                          </Grid>
                        </Grid>
                        <br/><br/><Divider/><br/><br/>
                        <Grid container>
                          <Grid size={{md: 3, sm: 5, xs: 12}} sx={
                            {paddingRight: '10px'}
                          }>
                            <div className="gt-title">{T('full_desc_title')}</div>
                          </Grid>
                          <Grid size={{md: 9, sm: 7, xs: 12}} sx={
                            {paddingRight: '10px'}
                          }>
                            <TextSlice lines={10} text={r.description} markdown showMore/>
                          </Grid>
                        </Grid>
                      </div>
                    ))}
                    <br/><br/><Divider/><br/><br/>
                    <Grid container>
                      <Grid size={{md: 3, sm: 5, xs: 12}} sx={
                        {paddingRight: '10px'}
                      }>
                        <div className="gt-title">{T('included_title')}</div>
                      </Grid>
                      <Grid size={{md: 9, sm: 7, xs: 12}} sx={
                        {paddingRight: '10px'}
                      }>
                        <div>
                          <div className="row gap-10"><Done style={{color: "green"}} />{T('inc_1')}</div>
                          <div className="row gap-10"><Done style={{color: "green"}} />{T('inc_2')}</div>
                        </div>
                      </Grid>
                    </Grid>
                    <br/><br/>
                    <Grid container>
                      <Grid size={{md: 3, sm: 5, xs: 12}} sx={
                        {paddingRight: '10px'}
                      }>
                        <div className="gt-title">{T('not_included_title')}</div>
                      </Grid>
                      <Grid size={{md: 9, sm: 7, xs: 12}} sx={
                        {paddingRight: '10px'}
                      }>
                        <div>
                          <div className="row gap-10"><Close style={{color: "red"}} />{T('ninc_1')}</div>
                          <div className="row gap-10"><Close style={{color: "red"}} />{T('ninc_2')}</div>
                          <div className="row gap-10"><Close style={{color: "red"}} />{T('ninc_3')}</div>
                        </div>
                      </Grid>
                    </Grid>
                    <br/><br/><Divider/><br/><br/>
                    <Grid container>
                      <Grid size={{md: 3, sm: 5, xs: 12}} sx={
                        {paddingRight: '10px'}
                      }>
                        <div className="gt-title">{T('important_title')}</div>
                      </Grid>
                      <Grid size={{md: 9, sm: 7, xs: 12}} sx={
                        {paddingRight: '10px'}
                      }>
                        <ul className="ul-list">
                          <li>{T('imp_1')}</li>
                          <li>⁠{T('imp_2')}</li>
                          <li>⁠{T('imp_3')}</li>
                          <li>⁠⁠{T('imp_4')}</li>
                        </ul>
                      </Grid>
                    </Grid>
                    {mobile && renderSuggestedTours()}
                  </Grid>
                  {!disabled && 
                    <Grid 
                      size={4} 
                      className={mobile ? 'tour-detail-floating2' : ''} 
                      id="tour-carrello"
                      sx={{ position: 'relative'}}
                      onClick={() => { 
                        if(mobile && showDetail) {
                          setShowDetail(0);
                        }
                      }}
                    >
                      <Card 
                        id="tour-carrello-card"
                        variant="outlined" sx={{marginTop: '15px', borderRadius: '25px', zIndex: 2}} 
                        onClick={(e) => {e.preventDefault(); e.stopPropagation()}}
                      >
                        <React.Fragment>
                          <CardContent>
                            <Typography variant="h5">
                              {T('tour_price')} {t.price}€
                            </Typography>
                            <br/>
                            <div className="column">
                              <DateStartInput variant="border" forceOpen={openDateSelection} onStartSetted={(v: any) => _setShowDetails(2, false, true, v)}/>
                            </div>
                          </CardContent>
                          <CardActions>
                            <div className="col pad-10" style={{ margin: '-15px -5px'}}>
                              {(showDetail > 0 && showDetail < 2) &&
                                <Button 
                                  variant="contained" size="large" sx={{borderRadius: '25px', padding: '15px'}} className="fullwidth" 
                                  onClick={() => _setShowDetails(2, false, true)}
                                  >
                                  {showDetail === 1 ? T('verify_btn2') : T('verify_btn3')}
                                </Button>
                              }
                              {showDetail === 0 &&
                                <Button 
                                  variant="contained" size="large" sx={{borderRadius: '25px', padding: '15px'}} className="fullwidth" 
                                  onClick={() => _setShowDetails(2, false, true)}
                                  >
                                    {T('verify_btn')}
                                  </Button>
                              }
                              {renderChartInfo()}
                            </div>
                          </CardActions>
                        </React.Fragment>
                      </Card>
                    </Grid>
                  }
                  {showDetail > 1 && mobile &&
                    renderChartInline()
                  }
                </Grid>
                {!mobile && renderSuggestedTours()}
              </div>
            </div>
          </div>
          {!disabled && 
            <div className='container' id="footer-fixed">
              <Grid container sx={{ display: { xs: !showDetail ? 'block': 'none', md: 'none' }, borderTopLeftRadius: '16px', borderTopRightRadius: '16px' }} className="bottom-bar-fixed">
                  <Grid size={12}>
                    <Button variant="contained" size="large" className="fullwidth" style={{borderRadius: '25px'}} 
                    onClick={() => {
                      window.scrollTo({
                        top: document.body.scrollHeight,
                        behavior: 'smooth'
                      });
                    }}
                    >{T('verify_btn')}</Button>
                  </Grid>
              </Grid> 
            </div>
          }
          <Modal
            open={showGally}
            onClose={() => setShowGallery(false)}
            className="no-outline"
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={modalCarouselStyle}>
              <AliceCarousel 
                items={images} 
                mouseTracking
                keyboardNavigation
                controlsStrategy="responsive"
                activeIndex={galleryPos}
                onSlideChanged={(p) => {_setGalleryPos(p.slide)}}
                renderPrevButton={() => (galleryPos === 0 ? <></> : <div className="img-gallery-prev"><ArrowBackIos/></div>)}
                renderNextButton={() => (galleryPos === images.length - 1 ? <></>:<div className="img-gallery-next"><ArrowForwardIos/></div>)}
              />
            </Box>
            {/* <Box sx={modalStyle} className="no-outline">
              <div className="img-gallery gap-20" id="image-gallery">
                {galleryPos > 0 &&
                  <div className="img-gallery-prev"  onClick={() => _setGalleryPos(galleryPos - 1)} >
                    <ArrowBack/>
                  </div>
                }
                {imageList.map((img: string, i: number) => (
                  <div className="fullwidth" key={img} id={`img-elem-${i}`}>
                    <img src={img} height={"100%"} />
                  </div>
                ))}
                {galleryPos < imageList.length - 1 &&
                  <div className="img-gallery-next" onClick={() => _setGalleryPos(galleryPos + 1)} >
                    <ArrowForward/>
                  </div>
                }
              </div>
              <Typography variant="h5" style={{textAlign: "center"}} className="pad-10">{galleryPos + 1} / {imageList.length}</Typography> 
            </Box>*/}
          </Modal>
      </>
    );
}


// Fasce orarie selezionabili per il tour. `start` è l'ora di inizio fascia,
// usata per applicare il cutoff di prenotazione (10h prima dell'inizio).
export const SLOT_OPTIONS = [
  { label: "9:00 - 10:00", start: 9 },
  { label: "10:00 - 11:00", start: 10 },
  { label: "11:00 - 12:00", start: 11 },
  { label: "12:00 - 13:00", start: 12 },
  { label: "13:00 - 14:00", start: 13 },
];

export function InfoForm({userInfos, items, onChange, onTallChange, onValidChange, onTimeRangeChange}:any) {

  let { account, setGoogleLoginToken, start } = useContext(StateContext) as State;

  const _initPhone = parsePhone(userInfos && userInfos.phone ? userInfos.phone : '');

  const [formData, setFormData] = useState({
    name: userInfos && userInfos.name ? userInfos.name : '',
    surname: userInfos && userInfos.surname ? userInfos.surname : '',
    email: userInfos && userInfos.email ? userInfos.email : '',
    phone: _initPhone.number ? `${_initPhone.prefix} ${_initPhone.number}` : ''
  });

  // Prefisso e numero locale gestiti separatamente nella UI, ma salvati insieme in formData.phone.
  const [phonePrefix, setPhonePrefix] = useState(_initPhone.prefix);
  const [phoneNumber, setPhoneNumber] = useState(_initPhone.number);

  // Consenso WhatsApp/SMS: obbligatorio SOLO per numeri USA/Canada (prefisso +1),
  // dove le regole sugli SMS transazionali richiedono un opt-in esplicito.
  // Per gli altri prefissi la checkbox non viene mostrata né validata.
  const [smsConsent, setSmsConsent] = useState(false);
  const consentRequired = phonePrefix === '+1';

  const formRef = useRef<any>(null);
  const [nameError, setNameError] = useState(false);
  const [surnameError, setSurnameError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const [timeRange, setTimeRange] = useState<any>(undefined);

  const _onTimeRangeChange = (value: string) => {
    setTimeRange(value)
    onTimeRangeChange(value)
  }

  // Se la data selezionata cambia e la fascia scelta non rispetta più il cutoff
  // di 10h (es. si passa a una data più vicina), azzero la selezione così
  // l'utente è costretto a sceglierne una valida.
  useEffect(() => {
    if (timeRange && start) {
      const opt = SLOT_OPTIONS.find((o) => o.label === timeRange)
      if (opt && !isSlotBookable(start, opt.start)) {
        setTimeRange(undefined)
        onTimeRangeChange(undefined)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [start])

  const checkValidity = () => {
    if(formRef && formRef.current && formRef.current) {
      // Validità nativa del form + consenso SMS (solo se richiesto, ovvero +1).
      const nativeValid = formRef.current.checkValidity();
      const consentOk = phonePrefix !== '+1' || smsConsent;
      onValidChange(nativeValid && consentOk)
    }
  }

  const handleChange = (event: any, callback: any) => {
    const { name, value } = event.target;
    setFormData((prevData) => {
      const obj = {
        ...prevData,
        [name]: value,
      };
      
      if (event.target.value) {
        if (!event.target.validity.valid) {
          callback(event.target.validationMessage);
        } else {
          callback(false);
        }
      }
      checkValidity()
      onChange(obj)
      return obj
    });
  };

  // Aggiorna formData.phone combinando prefisso + numero, es. "+39 3503254101".
  const updatePhone = (prefix: string, number: string) => {
    const combined = number ? `${prefix} ${number}` : '';
    setFormData((prevData) => {
      const obj = { ...prevData, phone: combined };
      onChange(obj);
      return obj;
    });
    checkValidity();
  };

  const handlePhoneNumberChange = (event: any) => {
    const number = event.target.value;
    setPhoneNumber(number);
    if (number) {
      setPhoneError(!event.target.validity.valid);
    } else {
      setPhoneError(false);
    }
    updatePhone(phonePrefix, number);
  };

  const handlePrefixChange = (event: any) => {
    const prefix = event.target.value;
    setPhonePrefix(prefix);
    updatePhone(prefix, phoneNumber);
  };

  const onItemChange = (i: number, value: string) => {
    onTallChange(i, Number(value))
    checkValidity()
  }

  useEffect(() => {
    checkValidity()
  }, [phonePrefix, smsConsent])

  return (
    <Box
      component="form"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '20px'
      }}
      autoComplete="off"
    >
      <form ref={formRef} className="col gap-20">
      <div className="row gap-20 el-flex">
        <TextField
          error={nameError}
          slotProps={{
            htmlInput: {pattern: "[A-Za-z ]+", minLength: 3},
          }}
          label="Name"
          name='name'
          value={formData.name}
          onChange={(e) => handleChange(e, setNameError)}
          variant="outlined"
          helperText={nameError ? nameError: ''}
          required
        />
        <TextField
          error={surnameError}
          slotProps={{
            htmlInput: {pattern: "[A-Za-z ]+", minLength: 3},
          }}
          label="Surname"
          name='surname'
          value={formData.surname}
          onChange={(e) => handleChange(e, setSurnameError)}
          variant="outlined"
          helperText={surnameError ? surnameError : ''}
          required
        />
      </div>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          gap: '20px',
          '& > *': { flex: 1, minWidth: 0 },
        }}
      >
        <TextField
          error={emailError}
          label="Email"
          name='email'
          type="email"
          value={formData.email}
          onChange={(e) => handleChange(e, setEmailError)}
          variant="outlined"
          helperText={emailError ? 'Inserisci un indirizzo email valido' : ''}
          required
        />
        <Box sx={{ display: 'flex', gap: '10px', minWidth: 0 }}>
          <FormControl variant="outlined" sx={{ width: 120, flexShrink: 0 }} required>
            <InputLabel id="phone-prefix-label">Prefisso</InputLabel>
            <Select
              labelId="phone-prefix-label"
              label="Prefisso"
              name='phonePrefix'
              value={phonePrefix}
              onChange={handlePrefixChange}
            >
              {PHONE_PREFIXES.map((p) => (
                <MenuItem key={p.label} value={p.code}>{p.label}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            error={phoneError}
            label="Phone"
            slotProps={{
              htmlInput: { pattern: "[0-9 ]+", minLength: 6, maxLength: 15, inputMode: "tel" },
            }}
            name='phone'
            type="text"
            value={phoneNumber}
            onChange={handlePhoneNumberChange}
            helperText={phoneError ? 'Inserisci un numero di telefono valido' : ''}
            variant="outlined"
            sx={{ flex: 1, minWidth: 0 }}
            required
          />
        </Box>
      </Box>
      {/* Consenso WhatsApp/SMS: mostrato e richiesto SOLO per numeri USA/Canada (+1). */}
      {consentRequired &&
        <FormControlLabel
          sx={{ alignItems: 'flex-start', margin: 0 }}
          control={
            <Checkbox
              checked={smsConsent}
              onChange={(e) => setSmsConsent(e.target.checked)}
              size="small"
              sx={{ pt: 0, mr: 1 }}
            />
          }
          label={
            <Typography variant="body2" sx={{ textAlign: 'left' }}>
              {smsConsentText()}
            </Typography>
          }
        />
      }
      {items.filter((i:any, index: number) => i.requireTallInfos ).length > 0 && 
      <>
        <div>
          <br/>
          <div className="gt-title">{T('datetime_title')}</div>
          <br/>
          <Select
            sx={{width: '200px'}}
            value={timeRange}
            required
            onChange={(e: any) => _onTimeRangeChange(e.target.value)}
          >
            {SLOT_OPTIONS.map((opt) => {
              // Fascia disabilitata se mancano meno di 10h al suo inizio.
              const bookable = !start || isSlotBookable(start, opt.start)
              return (
                <MenuItem key={opt.label} value={opt.label} disabled={!bookable}>
                  {opt.label}{!bookable ? ` — ${T('slot_too_late')}` : ''}
                </MenuItem>
              )
            })}
          </Select>
        </div>
        <br/>
        <div className="gt-title">{T('tall_title')}</div>
        <div className="row-wrap gap-10">
          <HeightSelector 
            onChange={(index: any, val: any) => onItemChange(index, val)} 
            values={items.map((c:any, index: number) => { return {...c, "index": index}}).filter((i:any) => i.requireTallInfos )} 
          />
        </div>
      </>
      }
      {!account && 
        <div>
          <Typography variant="body1"><b>{T('login_google_title')}</b></Typography>
          <br/>
          <GoogleLogin 
            theme="filled_blue"
            allowed_parent_origin={"https://www.outdoora.app"}
            onSuccess={credentialResponse => {
              setGoogleLoginToken(credentialResponse.credential)
            }}
            onError={() => {
              console.log('Login Failed');
            }}
          />
        </div>
      }
      </form>
    </Box>
  );
}


const PoiCard = ({poi, clicked, setClicked, index }:any) => {

  return (
    <>
      <div 
        className="card card-poi" 
        onClick={() => {setClicked(index)}}
      >
        <LazyImage src={poi.image} style={{ height: 180 }} />
        <CardContent>
          <Typography variant="h6">{poi.name}</Typography>
          <br/>
          {poi.description &&
            <Typography variant="subtitle1" style={{fontSize: 14}}>
            <TextSlice text={poi.description} lines={5}/></Typography>
          }
          {/* <Typography>Type: {poi.type}</Typography> */}
        </CardContent>
      </div>
      <Modal
        open={clicked}
        onClose={() => {
          setClicked(false)
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="no-outline"
      >
        <Box sx={modalPoiStyle}>
          <div className="poi-modal-close" onClick={() => setClicked(false)}>
            <Close />
          </div>
          <LazyImage src={poi.image} style={{ height: 300 }} />
          <div className="pad-20 poi-modal">
            <Typography variant="h6">{poi.name}</Typography>
            {poi.description &&
              <>
                <br/>
                <Typography variant="subtitle1" style={{fontSize: 14}}>
                  {poi.description}
                </Typography>
              </>
            }
          </div>
        </Box>
      </Modal>
    </>
  )
}
